import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { IoCloseCircle } from 'react-icons/io5';
import { BiMenu } from 'react-icons/bi';

const Layout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 799) {
        setSidebarOpen(false);
      }
    };

    handleResize(); // Run on mount in case the screen is already small
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);

  return (
    <div className="flex h-svh overflow-hidden bg-gray-100">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} onToggle={setSidebarOpen} />

      {/* Main content */}
      <div className="flex flex-col flex-1 min-h-0 min-w-0">
        {/* Mobile Header */}
        <header className="md:hidden flex items-center justify-between p-4 bg-gray-800 text-white flex-shrink-0">
          <button onClick={toggleSidebar}>
            {isSidebarOpen ? (
              <IoCloseCircle className="w-6 h-6" />
            ) : (
              <BiMenu className="w-6 h-6" />
            )}
          </button>
          <h1 className="text-lg font-semibold">Dashboard</h1>
        </header>

        {/* Content Area */}
        <main className="flex-1 overflow-auto p-4 w-full max-w-full">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
